import {
  GET_LANDING_DROPDOWN_LIST,
  GET_LANDING_DROPDOWN_LIST_FAILED,
  GET_LANDING_DROPDOWN_LIST_SUCCESS,
  GET_LANDING_SETUP,
  GET_LANDING_SETUP_FAILED,
  GET_LANDING_SETUP_SUCCESS,
  UPDATE_LANDING_FEATURE_ORDER,
  UPDATE_LANDING_SETUP,
  UPDATE_LANDING_SETUP_FAILED,
  UPDATE_LANDING_SETUP_SUCCESS,
} from "./actionTypes"

const INITIAL_STATE = {
  landingSetup: null,
  loading: false,
  error: "",
  landingDropdownList: [],
}

const LandingScreen = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_LANDING_SETUP:
    case GET_LANDING_DROPDOWN_LIST:
    case UPDATE_LANDING_SETUP:
      return {
        ...state,
        loading: true,
      }
    case GET_LANDING_SETUP_SUCCESS:
    case UPDATE_LANDING_SETUP_SUCCESS:
    case UPDATE_LANDING_FEATURE_ORDER:
      return {
        ...state,
        landingSetup: action.payload,
        loading: false,
      }
    case GET_LANDING_SETUP_FAILED:
    case GET_LANDING_DROPDOWN_LIST_FAILED:
    case UPDATE_LANDING_SETUP_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case GET_LANDING_DROPDOWN_LIST_SUCCESS:
      return {
        ...state,
        landingDropdownList: action.payload,
        loading: false,
      }
    default:
      return state
  }
}

export default LandingScreen
